// noinspection DuplicatedCode

import { container, singleton } from 'tsyringe';
import {
    authorizationHandler,
    AxiosHttp,
    Http,
    HttpStateCodeHandler,
    RequestFail,
    QueryStringObject,
    RequestInterceptor,
    ResponseInterceptor,
} from '@/Http';
import { BusinessResult } from '@/Domain';
import { ClientError } from '@/Client';
import { 提示Service, 提示ServiceInjectToken } from '@/Services';

@singleton()
export class MainClient {
    static SecuredClient(baseUrl: string, onUnauthorize?: () => void) {
        return new MainClient(baseUrl, [authorizationHandler], [HttpStateCodeHandler], onUnauthorize);
    }
    static UnsecuredClient(baseUrl: string) {
        return new MainClient(baseUrl, [], [HttpStateCodeHandler]);
    }

    private readonly _baseUrl: string;
    private _onUnauthrized: (() => void) | undefined;

    constructor(
        baseUrl: string,
        requestInterceptors: RequestInterceptor[],
        responseInterceptors: ResponseInterceptor[],
        onUnauthorize?: () => void
    ) {
        this._http = new AxiosHttp<BusinessResult<unknown>>({}, requestInterceptors, responseInterceptors);
        this._baseUrl = baseUrl;
        //TODO 对于Navigator更好的封装之后，应该可以替换下面这个callback
        this._onUnauthrized = onUnauthorize;
    }

    private _http: Http<BusinessResult<unknown>>;

    public get<T>(url: string, query?: QueryStringObject): Promise<T> {
        return new Promise((resolve, reject) => {
            const promise = this._http.get(this.getFullUrl(url), query) as Promise<BusinessResult<T>>;
            promise.then(this.BusinessErrorFilter(resolve, reject)).catch((requestFail: RequestFail) => {
                reject('错误:' + requestFail);
                if (requestFail === RequestFail.需要授权 && this._onUnauthrized) this._onUnauthrized();
                else container.resolve<提示Service>(提示ServiceInjectToken).提示错误('错误:' + requestFail);
            });
        });
    }

    public post<T>(url: string, data?: unknown, query?: QueryStringObject): Promise<T> {
        return new Promise((resolve, reject) => {
            const promise = this._http.post(this.getFullUrl(url), data, query) as Promise<BusinessResult<T>>;
            promise.then(this.BusinessErrorFilter(resolve, reject)).catch((requestFail: RequestFail) => {
                reject('错误:' + requestFail);
                if (requestFail === RequestFail.需要授权 && this._onUnauthrized) this._onUnauthrized();
                else container.resolve<提示Service>(提示ServiceInjectToken).提示错误('错误:' + requestFail);
            });
        });
    }

    private BusinessErrorFilter<T>(
        resolve: (value: PromiseLike<T> | T) => void,
        reject: (reason?: ClientError) => void
    ) {
        return (res: BusinessResult<T>) => {
            switch (res.state) {
                case 'Failed': {
                    const notifyService = container.resolve<提示Service>(提示ServiceInjectToken);
                    notifyService.提示错误(res.description);
                    reject('操作错误');
                    break;
                }
                case 'Fatal': {
                    const notifyService = container.resolve<提示Service>(提示ServiceInjectToken);
                    notifyService.提示错误(`系统错误：${res.description}`);
                    reject('系统错误');
                    break;
                }
                default:
                    resolve(res.data);
            }
        };
    }

    private getFullUrl(url: string) {
        return this._baseUrl + url;
    }
}
